module.exports = __webpack_public_path__ + "img/catalogBtnDark.2679d070.png";